import React, { FC } from 'react'
import classNames from 'classnames'
import { motion } from 'framer-motion'
import DynamicSVG from '../../../atoms/DynamicSvg/DynamicSvg'
import { getImage } from '../../../../app/utlis/imageConstants'

interface WebsiteSuppIdeaProjectProps {
    websiteSupportData: any
}

const WebsiteSuppIdeaProject: FC<WebsiteSuppIdeaProjectProps> = ({ websiteSupportData }) => {
    return (
        <div>
            <div className='flex flex-col gap-5 md:gap-10 bg-darkGreyPrimary mt-4 md:mt-8'>
                {websiteSupportData.WebsiteSupportIdeaProjectsData.map((projects: any, index: number) => {
                 let img = getImage(projects.image ?? "") ?? "";
                    return (
                        <motion.div 
                            key={index}
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.2 }}
                            transition={{ 
                                duration: 0.7, 
                                ease: "easeOut",
                                delay: 0.2 * index
                            }}
                            whileHover={{ scale: 1.01 }}
                            className={`min-h-96 h-auto flex items-center justify-center`}
                        >
                            <div className={`w-[80%] flex flex-col ${projects.row === 'row' ? 'md:flex-row' : 'md:flex-row-reverse'} justify-center p-6 border-[0.2px] border-${projects.textColor}`}>

                           
                            <motion.div 
                                className={classNames('flex flex-col w-full  px-4 sm:px-6 md:pl-10 md:pr-8 lg:pr-16', `justify-center`)}
                                initial={{ opacity: 0, x: -20 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.5, delay: 0.3 + (0.1 * index) }}
                            >
                                <div className={classNames('font-semibold text-2xl md:text-3xl lg:text-4xl', `text-${projects.textColor}`)} >{projects.key}.</div>
                                <div className={classNames('font-semibold text-2xl md:text-3xl lg:text-4xl mb-2', `text-${projects.textColor}`)} >{projects.title}</div>
                                <ul className='list-disc flex flex-col gap-2 md:gap-3 pl-5'>
                                    {projects.list.map((proj: any, listIndex: number) => {
                                        return (
                                            <motion.li
                                                key={listIndex}
                                                initial={{ opacity: 0, x: -10 }}
                                                whileInView={{ opacity: 1, x: 0 }}
                                                viewport={{ once: true }}
                                                transition={{ 
                                                    duration: 0.3, 
                                                    delay: 0.4 + (0.05 * listIndex) 
                                                }}
                                            >
                                                <div className='text-white text-start text-sm md:text-md pr-2 md:pr-8 font-bold'>{proj.title}</div>
                                                <div className='text-white text-start text-xs md:text-sm pr-2 md:pr-8'> {proj.subTitle}</div>
                                            </motion.li>
                                        )
                                    })}
                                </ul>
                            </motion.div>
                            <motion.div 
                                className={`w-full md:w-[60%] h-auto overflow-hidden bg-blackDark flex items-center justify-center`}
                                initial={{ opacity: 0, scale: 0.9 }}
                                whileInView={{ opacity: 1, scale: 1 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.5, delay: 0.4 + (0.1 * index) }}
                                whileHover={{ scale: 1.05 }}
                            >
                                {/* <img src={projects.image} className="w-[80%] h-auto" alt={projects.title} /> */}
                                <DynamicSVG size='w-[80%] h-auto'>{img}</DynamicSVG>
                            </motion.div>
                             </div>
                        </motion.div>
                    )
                })}
            </div>
        </div>
    )
}

export default WebsiteSuppIdeaProject
